// import { AddRegistryMethodType } from '../Catalog.telemetry.types';

import { AddRegistryMethodType, PagesForTelemetry } from '../Catalog.telemetry.types';

export function generateRegistryItemMetadataSourceFromCatalog(method: AddRegistryMethodType, pageValue: PagesForTelemetry) {
  let source = 'catalogShop';
  if (method === 'related products quick add') {
    source = 'recommendedCatalogShop';
  } else if (pageValue === 'searchResults') {
    source = 'catalogSearch';
  }
  return source;
}
